'use es6';

import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UISelect from 'UIComponents/input/UISelect';
import UITextInput from 'UIComponents/input/UITextInput';
import UIModal from 'UIComponents/dialog/UIModal';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import H2 from 'UIComponents/elements/headings/H2';
import { URL_REGEX_WITHOUT_PROTOCOL_REGEX } from 'ContentEditorUI/utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageExpiryExternalUrlModal = ({
  closeModal,
  onCreateExternalUrl
}) => {
  const [externalUrlPath, setExternalUrlPath] = useState('');
  const [externalUrlPrefix, setExternalUrlPrefix] = useState('http://');
  const isValid = URL_REGEX_WITHOUT_PROTOCOL_REGEX.test(externalUrlPath);
  const getLangKey = key => `pageSettings.form.unpublish.modal.${key}`;
  return /*#__PURE__*/_jsxs(UIModal, {
    size: "auto",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('title')
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(UIInputGroup, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('label')
        }),
        use: "itemLeft",
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          error: !isValid && externalUrlPath,
          children: /*#__PURE__*/_jsx(UISelect, {
            onChange: e => setExternalUrlPrefix(e.target.value),
            value: externalUrlPrefix,
            options: [{
              text: 'http://',
              value: 'http://'
            }, {
              text: 'https://',
              value: 'https://'
            }]
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          error: !isValid && externalUrlPath,
          validationMessage: !isValid && /*#__PURE__*/_jsx(FormattedMessage, {
            message: getLangKey('invalidUrl')
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: externalUrlPath,
            onChange: e => setExternalUrlPath(e.target.value),
            placeholder: I18n.text(getLangKey('placeholder'))
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: externalUrlPath.length > 0,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('invalidUrl')
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: () => onCreateExternalUrl(externalUrlPrefix, externalUrlPath),
          disabled: !isValid,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getLangKey('createUrlButton')
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('cancelText')
        })
      })]
    })]
  });
};
PageExpiryExternalUrlModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onCreateExternalUrl: PropTypes.func.isRequired
};
export default PageExpiryExternalUrlModal;